"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.royaltyFormValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.royaltyFormValidationSchema = (0, yup_1.object)().shape({
    royalty: yup_rules_1.currencyValidationSchema.max(10000, "form.validations.rangeOverflow"),
});
//# sourceMappingURL=validation.js.map